"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _uuid = require("uuid");
var _useLazyRef = _interopRequireDefault(require("../../hooks/useLazyRef"));
var _useMenu = _interopRequireDefault(require("../Menu/hooks/useMenu"));
var _ListItem = _interopRequireDefault(require("../ListItem"));
var _Menu = _interopRequireDefault(require("../Menu"));
var Styled = _interopRequireWildcard(require("./style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var SubMenu = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var children = props.children,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    targeted = props.targeted,
    filteredProps = __rest(props, ["children", "onMouseEnter", "onMouseLeave", "targeted"]);
  var timeoutId = (0, _react.useRef)();
  var hasBeenVisted = (0, _react.useRef)(false);
  var id = (0, _useLazyRef.default)(function () {
    return (0, _uuid.v4)();
  });
  var _a = (0, _useMenu.default)() || {},
    activeSubMenuId = _a.activeSubMenuId,
    addSubMenu = _a.addSubMenu,
    removeSubMenu = _a.removeSubMenu,
    onClickOutside = _a.onClickOutside;
  var _b = (0, _react.useState)(null),
    listItemRef = _b[0],
    setListItemRef = _b[1];
  var _c = (0, _react.useState)({
      x: 0,
      y: 0
    }),
    offset = _c[0],
    setOffset = _c[1];
  var _d = (0, _react.useState)(false),
    showSubMenu = _d[0],
    setShowSubMenu = _d[1];
  (0, _react.useImperativeHandle)(ref, function () {
    return listItemRef;
  }, [listItemRef]);
  (0, _react.useEffect)(function () {
    var handleOnKeyDown = function handleOnKeyDown(event) {
      switch (event.code) {
        case 'ArrowRight':
          {
            event.preventDefault();
            event.stopPropagation();
            setShowSubMenu(true);
            break;
          }
        case 'ArrowLeft':
          {
            if (activeSubMenuId === id.current) {
              event.preventDefault();
              event.stopPropagation();
              setShowSubMenu(false);
            }
            break;
          }
      }
    };
    if (targeted) {
      window.addEventListener('keydown', handleOnKeyDown);
    }
    return function () {
      return window.removeEventListener('keydown', handleOnKeyDown);
    };
  }, [activeSubMenuId, targeted, id]);
  (0, _react.useEffect)(function () {
    if (listItemRef) {
      var listItemRect = listItemRef.getBoundingClientRect();
      var subMenuOffset = {
        x: listItemRect.width - 5,
        y: -(listItemRect.height + 5)
      };
      setOffset(subMenuOffset);
    }
  }, [listItemRef]);
  (0, _react.useEffect)(function () {
    var subMenuId = id.current;
    if (showSubMenu) {
      addSubMenu === null || addSubMenu === void 0 ? void 0 : addSubMenu(subMenuId);
    } else {
      removeSubMenu === null || removeSubMenu === void 0 ? void 0 : removeSubMenu(subMenuId);
    }
  }, [id, showSubMenu, addSubMenu, removeSubMenu]);
  (0, _react.useEffect)(function () {
    var subMenuId = id.current;
    return function () {
      return removeSubMenu === null || removeSubMenu === void 0 ? void 0 : removeSubMenu(subMenuId);
    };
  }, [id, removeSubMenu]);
  var handleOnMouseEnterListItem = (0, _react.useCallback)(function (event) {
    hasBeenVisted.current = false;
    if (typeof onMouseEnter === 'function') {
      onMouseEnter(event);
    }
    setShowSubMenu(true);
  }, [onMouseEnter]);
  var handleOnMouseLeaveListItem = (0, _react.useCallback)(function (event) {
    if (typeof onMouseLeave === 'function') {
      onMouseLeave(event);
    }
    timeoutId.current = setTimeout(function () {
      setShowSubMenu(false);
    }, 50);
  }, [onMouseLeave]);
  var handleOnMouseEnterList = (0, _react.useCallback)(function () {
    hasBeenVisted.current = true;
    clearTimeout(timeoutId.current);
  }, []);
  var handleOnMouseLeaveList = (0, _react.useCallback)(function () {
    if (!hasBeenVisted.current) {
      setShowSubMenu(false);
    }
  }, []);
  var isTargeted = showSubMenu || targeted ? true : false;
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_ListItem.default, __assign({}, filteredProps, {
      targeted: isTargeted,
      onMouseEnter: handleOnMouseEnterListItem,
      onMouseLeave: handleOnMouseLeaveListItem,
      ref: setListItemRef
    }, {
      children: (0, _jsxRuntime.jsx)(Styled.SubMenuIcon, {
        "$targeted": isTargeted
      })
    })), (0, _jsxRuntime.jsx)(_Menu.default, __assign({
      offset: offset,
      show: showSubMenu,
      anchor: listItemRef,
      onClickOutside: onClickOutside,
      listProps: {
        onMouseEnter: handleOnMouseEnterList,
        onMouseLeave: handleOnMouseLeaveList
      }
    }, {
      children: children
    }))]
  });
});
SubMenu.displayName = 'SubMenu';
var _default = SubMenu;
exports.default = _default;